
import Moderator from '@/models/bread/Moderator/eventFinisher'


export default {
    key: 'EventFinisher',
    name: {
        singular: 'Finisher',
        plural: 'Finishers',
    },
    parents: [
        'Event',
    ],
    Admin: false,
    Moderator: Moderator,
    Teacher: false,
}